import { useContext } from 'react';

import { TenantedApplicationConfigContext } from '../../TenantedApplicationConfigContext';
import { TenantedApplicationConfig } from '../../types/TenantedApplicationConfig';

export const useTenantedApplicationConfig = (): TenantedApplicationConfig => {
  const context = useContext(TenantedApplicationConfigContext);

  if (!context) {
    throw new Error(
      'useTenantedApplicationConfig must be used within a TenantedApplicationConfigProvider',
    );
  }
  return context;
};
